var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pcc-card" },
    [
      _c("div", { staticClass: "pcc-header" }, [
        _c("div", { staticClass: "pcc-title" }, [
          _c(
            "span",
            { staticClass: "pcc-drag-handle", attrs: { title: "Sürükle" } },
            [_vm._v("≡")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "pcc-title-text" }, [
            _vm._v(_vm._s(_vm.getContentName(_vm.content))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pcc-actions" },
          [
            _vm.canCreateItems
              ? _c(
                  "SupsisButton",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { content: _vm.altLabel },
                        expression: "{ content: altLabel }",
                      },
                    ],
                    attrs: { icon: "", square: "", small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit(
                          "add-to-title",
                          _vm.content,
                          _vm.contentTypes.ALT
                        )
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("keyboard")])],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canCreateItems
              ? _c(
                  "SupsisButton",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { content: _vm.tabLabel },
                        expression: "{ content: tabLabel }",
                      },
                    ],
                    attrs: { icon: "", square: "", small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit(
                          "add-to-title",
                          _vm.content,
                          _vm.contentTypes.TAB
                        )
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("space_bar")])],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canCreateItems
              ? _c(
                  "SupsisButton",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { content: _vm.hashLabel },
                        expression: "{ content: hashLabel }",
                      },
                    ],
                    attrs: { icon: "", square: "", small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit(
                          "add-to-title",
                          _vm.content,
                          _vm.contentTypes.HASH
                        )
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("tag")])],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { content: _vm.$t("message.edit") },
                    expression: "{ content: $t('message.edit') }",
                  },
                ],
                attrs: { icon: "", square: "", small: "" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("edit", _vm.content._id)
                  },
                },
              },
              [_c("md-icon", [_vm._v("edit")])],
              1
            ),
            _vm._v(" "),
            _vm.canDeleteCategory
              ? _c(
                  "SupsisButton",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { content: _vm.$t("message.deleteField") },
                        expression: "{ content: $t('message.deleteField') }",
                      },
                    ],
                    attrs: {
                      icon: "",
                      square: "",
                      small: "",
                      classNames: "pcc-delete-btn",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("remove", _vm.content._id)
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("delete")])],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "draggable",
        {
          key: _vm.content._id,
          staticClass: "pcc-list",
          attrs: {
            id: _vm.content._id,
            move: _vm.move,
            group: "contents",
            options: { handle: ".pci-drag" },
            disabled: _vm.disabled,
          },
          on: {
            end: function ($event) {
              return _vm.$emit("move-end", $event)
            },
          },
          model: {
            value: _vm.content.children,
            callback: function ($$v) {
              _vm.$set(_vm.content, "children", $$v)
            },
            expression: "content.children",
          },
        },
        _vm._l(_vm.content.children || [], function (child) {
          return _c("PreparedContentsItemRow", {
            key: child._id,
            attrs: {
              id: child._id,
              child: child,
              "is-mac": _vm.isMac,
              "is-dark-mode": _vm.isDarkMode,
              "can-delete": _vm.canDeleteItem,
              "get-content-name": _vm.getContentName,
            },
            on: { edit: _vm.handleEdit, remove: _vm.handleRemove },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }